const awsExports = {
    Auth: {
        Cognito: {
            userPoolId: window.config.COGNITO_USER_POOL_ID,
            userPoolClientId: window.config.COGNITO_USER_POOL_CLIENT_ID,
            region: window.config.COGNITO_REGION,
            loginWith: {
                oauth: {
                    domain: window.config.COGNITO_DOMAIN,
                    scopes: ['email', 'profile', 'openid', 'phone'],
                    redirectSignIn: [window.config.COGNITO_REDIRECT_SIGN_IN],
                    redirectSignOut: [window.config.COGNITO_REDIRECT_SIGN_OUT],
                    responseType: 'code',
                },
            },
        },
    },
};

export default awsExports;
